//@ts-nocheck
import axios from 'axios';
import API_ENDPOINTS from '../../../const/ApiEndPoints';
import { useCallback } from 'react';

export default function useTemplateVersion() {
  /**
   * This API fetches the list of template versions for a given template.
   * @param {string} template_id - uuid of the template.
   */
  const getTemplateVersionList = useCallback((body, loader = true) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.GET_TEMPLATE_VERSIONS}`,
        { params: body, loader }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  }, []);

  /**
   * This API publishes the provided template version.
   *
   * If `set_as_default` is true, the version will be published and marked as
   * the default version for the given template.
   * If `set_as_default` is false, the version will only get published
   *
   * @param {string} template_id - uuid of the template.
   * @param {string} version_id -  uuid of version .
   * @param {boolean} set_as_default - Whether to set this version as default .
   */
  const publishDefaultTemplateVersion = (body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.PUBLISH_TEMPLATE_VERSION}`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  /**
   * This API updates the default template version. but only if version is published
   */
  const updateDefaultTemplateVersion = (body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.SET_DEFAULT_TEMPLATE_VERSION}`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const createNewTemplateVersion = (body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.CREATE_TEMPLATE_VERSION}`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  /**
   * Migrate entities to a specific template version.
   *
   * This API migrates selected entities (or all entities) from one template version
   * to another target version.
   *
   * @param {string} body.template_id - UUID of the template.
   * @param {string} [body.source_version_id] - [optional] - UUID of the source version (if not provided then will migrate all version entites to target version).
   * @param {string} body.target_version_id - UUID of the version to migrate entities to.
   * @param {number[]} [body.entity_ids] - List of entity IDs to migrate.
   * @param {boolean} body.reset_workflow - Whether to reset workflow of these entities.
   */
  const migrateEntitiesToTemplateVersion = (body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.MIGRATE_ENTITIES_TO_TEMPLATE_VERSION}`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  /**
   * This API compares two template versions.
   *
   * @param {string} body.template_id - UUID of the template.
   * @param {string} body.version_a_id - UUID of the version A.
   * @param {string} body.version_b_id - UUID of the version B.
   */
  const compareTemplateVersions = (body) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.COMPARE_TEMPLATE_VERSIONS}`,
        { params: body }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  return {
    getTemplateVersionList,
    publishDefaultTemplateVersion,
    updateDefaultTemplateVersion,
    createNewTemplateVersion,
    migrateEntitiesToTemplateVersion,
    compareTemplateVersions,
  };
}
